import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import dayjs from 'dayjs';
import { BehaviorSubject, Observable } from 'rxjs';
import { AnnouncementBanner } from 'src/app/shared/models/AnnouncementBanner';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementBannerService {

  
  private _hideNotificationBannerOnMobile: BehaviorSubject<boolean> = new BehaviorSubject(true);
  private _hideNotificationBannerOnDesktop: BehaviorSubject<boolean> = new BehaviorSubject(true);
  public hideNotificationBannerOnMobile: Observable<boolean>;
  public hideNotificationBannerOnDesktop: Observable<boolean>;

  private _previewAlert: BehaviorSubject<AnnouncementBanner | null> = new BehaviorSubject<AnnouncementBanner | null>(null);
  //public previewAlert: Observable<NotificationBanner>;

  constructor(private http: HttpClient, private storage: LocalStorageService) {
    this.hideNotificationBannerOnMobile = this._hideNotificationBannerOnMobile.asObservable();
    this.hideNotificationBannerOnDesktop = this._hideNotificationBannerOnDesktop.asObservable();
    // this.previewAlert = this._previewAlert.asObservable();
  }

  /*get(params: HttpParams): Observable<NotificationBanner[]> {
    return this.http.get(environment.apiBaseUrl + '/alert', {params: params}).pipe(map((result: PaginatableInterface) => {
      return result.data.map(item => NotificationBanner.create(item));
    }));
  }*/

  /*update(notificationBanner: NotificationBanner, editLocale = false): Observable<NotificationBanner> {
    return this.http.put(environment.apiBaseUrl + '/alert/' + notificationBanner.id, notificationBanner).pipe(map((result: NotificationBanner) => {
      return NotificationBanner.create(result);
    }));
  }*/

  hasDismissedBefore() {
    return localStorage.getItem('notification-banner');
  }

  dismiss() {
    this.storage.setItem('notification-banner', dayjs().format());
  }

  hideOnMobile() {
    this.dismiss();
    this._hideNotificationBannerOnMobile.next(true);
    // this.globalHelperService.showBodyScroll();
  }

  hideOnDesktop() {
    this.dismiss();
    this._hideNotificationBannerOnDesktop.next(true);
    // this.globalHelperService.showBodyScroll();
  }

  showOnMobile(time: any, force = false) {
    if (!this.hasDismissedBefore() || force) {
      setTimeout(() => {
        this._hideNotificationBannerOnMobile.next(false);
        // this.globalHelperService.hideBodyScroll();
      }, time);
    }
  }

  showOnDesktop(force = false) {
    if (!this.hasDismissedBefore() || force) {
      this._hideNotificationBannerOnDesktop.next(false);
    }
  }

  showPreview(data: AnnouncementBanner) {
    this._previewAlert.next(data);
  }

}
